import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'integer'
})
export class IntegerPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    return Math.round(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/integer.pipe.ts